/**
 * 品牌 表单验证规则
 * @author zjs
 * @time 2017-12-12
 */
export default {
    data () {
        return {
            formRules: {
                'brand_name' : [{ required: true, trigger: 'blur' }],
                'jindie_id': [{ required: true, trigger: 'blur' }]
            }
        }
    }
}